var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmationPlant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 289,
    viewBox: "0 0 166 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9867 329C61.475 329 61.8005 329 62.2888 328.837C76.6123 323.629 83.7741 236.389 84.5879 226.461L82.1464 226.298C79.2166 264.71 71.241 322.978 61.475 326.559C60.9867 326.722 60.6611 326.722 60.1728 326.396C51.0579 320.048 48.2908 247.783 48.1281 220.439H45.6866C45.8493 230.693 46.9887 320.048 58.8707 328.349C59.359 328.675 60.1728 329 60.9867 329Z",
    fill: "url(#paint0_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0382 322.001C24.3638 322.001 24.6893 322.001 25.1776 322.001C52.3597 319.234 56.5916 229.553 56.7544 225.81L54.3129 225.647C54.3129 226.624 49.9182 316.956 24.8521 319.56C24.5265 319.56 24.201 319.56 24.0382 319.56C3.85511 319.56 -8.67795 245.341 -11.7705 216.207L-14.212 216.533C-13.7237 220.764 -2.4928 322.001 24.0382 322.001Z",
    fill: "url(#paint1_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1919 213.766L74.3333 264.221L70.9152 267.639L53.8247 277.242L47.4767 291.077L14.9233 299.54L-2.1672 293.681L-12.9098 291.077L-35.5344 213.766H87.1919Z",
    fill: "url(#paint2_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3335 264.221L67.6601 267.639L35.5949 268.616L30.2236 270.732L15.2491 281.637L-12.9096 291.077L-2.167 293.681L14.9235 299.54L47.4769 291.077L53.8249 277.242L70.9154 267.639L74.3335 264.221Z",
    fill: "url(#paint3_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9152 266.012C69.2876 267.802 38.1991 266.5 36.2459 266.012C34.2927 265.524 33.3161 226.461 36.2459 220.602C39.1757 214.742 83.6111 215.231 84.9132 216.207C86.3781 217.346 74.0078 262.431 70.9152 266.012Z",
    fill: "#FF5E31"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2458 215.556C37.7107 216.858 33.8043 224.996 32.1766 226.136C30.5489 227.275 17.0393 217.347 17.0393 215.556C17.0393 213.766 34.6181 214.091 36.2458 215.556Z",
    fill: "#FF5E31"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1767 267.476C34.1299 265.361 33.3161 233.134 30.7118 228.902C28.1075 224.67 11.9936 216.37 5.64569 217.346C-0.702229 218.323 -13.5608 245.667 -13.0725 256.572C-12.4215 267.476 6.45952 280.335 10.0404 280.172C13.6213 280.009 30.0607 269.755 32.1767 267.476Z",
    fill: "#FF5E31"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7046 240.133L34.4554 241.272V245.016L78.728 243.388L79.7046 240.133Z",
    fill: "#FF862F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0069 235.25L34.6183 232.483L35.2694 225.159L83.2856 226.298L81.0069 235.25Z",
    fill: "#FF862F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8276 241.272L-9.98011 242.574L-12.2589 250.549L33.3159 251.526L32.8276 241.272Z",
    fill: "url(#paint4_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.825 277.242L39.6643 272.522H28.4333L17.2024 281.799L25.8291 289.449L47.4771 291.077L14.9237 299.54L-2.16686 293.681L-12.9095 291.077L15.2492 281.637L30.2238 270.732L35.5951 268.616L70.9155 267.639L53.825 277.242Z",
    fill: "url(#paint5_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3322 237.203C81.3322 237.203 69.613 222.067 59.847 221.09C50.0809 220.113 35.2691 225.159 35.2691 225.159L31.2 230.205C31.2 230.205 -3.30666 221.416 -30.8143 230.205L-35.0462 215.556L84.9131 216.207L81.3322 237.203Z",
    fill: "url(#paint6_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2856 213.766C83.2856 213.766 101.19 208.883 112.909 215.556L91.0984 217.184C91.0984 217.184 96.958 232.158 95.1676 235.087C93.3771 238.017 74.3334 225.159 74.3334 225.159L76.4494 231.507C76.4494 231.507 70.5898 220.927 61.8003 217.346C53.0109 213.766 -9.32887 225.322 -13.0725 225.159C-16.8161 224.996 -17.1417 218.649 -17.1417 218.649C-17.1417 218.649 -38.7897 224.508 -43.8355 225.159C-43.8355 225.159 -42.5333 213.766 -34.7205 211.975L-47.0908 204C-47.0908 204 -38.7897 202.861 -27.0705 213.115L83.2856 213.766Z",
    fill: "url(#paint7_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2856 213.766C83.2856 213.766 8.73833 219.951 -27.0704 213.277L83.2856 213.766Z",
    fill: "#FFFF70"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.2399 213.277C78.2399 213.277 91.5868 236.715 87.1921 234.273C80.0304 230.204 68.9622 216.533 61.8005 213.766L78.2399 213.277Z",
    fill: "url(#paint8_radial_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4554 245.016L38.3618 248.759L36.4086 256.572L33.316 259.339L28.1075 254.13L28.9213 246.318L34.4554 245.016Z",
    fill: "url(#paint9_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3618 248.759L35.9203 251.526L29.7352 250.061L28.9213 246.318L25.8288 252.177V259.339L30.7118 261.292L33.316 259.339L36.4086 256.572L38.3618 248.759Z",
    fill: "url(#paint10_linear_1_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3618 248.759L35.9203 251.526L30.0607 250.224L28.9213 246.318L34.4554 245.016L38.3618 248.759Z",
    fill: "#BCABBC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.32617 186.627C-1.32617 186.627 5.99755 12.8247 18.7411 3.25797C31.3379 -6.06548 59.219 47.2696 59.3501 90.4939C59.4811 133.718 5.98489 186.062 5.98489 186.062L-1.32617 186.627Z",
    fill: "url(#paint11_radial_1_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31645 189.912C6.31645 189.912 46.037 150.495 65.9276 147.233C85.8181 143.971 112.699 169.82 112.879 175.571C112.815 181.174 13.128 194.023 13.128 194.023L6.31645 189.912Z",
    fill: "url(#paint12_radial_1_2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3161 189.912C6.3161 189.912 59.5819 76.3627 31.7598 19.0806C31.7598 19.0806 63.3533 69.0142 13.1277 194.023L6.3161 189.912Z",
    fill: "url(#paint13_linear_1_2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.878 175.571C112.878 175.571 77.2026 140.099 6.31615 189.912C6.31615 189.912 69.9592 133.404 112.878 175.571Z",
    fill: "url(#paint14_linear_1_2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1277 194.023C13.1277 194.023 80.3407 132.701 35.9618 89.6534C30.178 83.8394 -1.17912 186.384 -1.17912 186.384L13.1277 194.023Z",
    fill: "url(#paint15_radial_1_2)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89556 191.137C8.89556 191.137 56.8427 136.44 36.205 89.8C36.205 89.8 58.0345 127.867 4.56277 189.518L8.89556 191.137Z",
    fill: "url(#paint16_linear_1_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.9894 274.605) rotate(180) scale(40.8181 40.8164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.279 269.084) rotate(180) scale(45.0184 45.0166)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2",
    x1: 25.8966,
    y1: 299.495,
    x2: 25.8966,
    y2: 213.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F2726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AB401D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_2",
    x1: 74.3877,
    y1: 281.826,
    x2: -12.964,
    y2: 281.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974577"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_2",
    x1: 33.2796,
    y1: 246.381,
    x2: -12.3303,
    y2: 246.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974577"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_2",
    x1: 70.8612,
    y1: 283.6,
    x2: -12.9639,
    y2: 283.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974577"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_2",
    x1: 25.0052,
    y1: 237.233,
    x2: 25.0052,
    y2: 215.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974577"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9499 219.795) rotate(180) scale(57.6324 57.63)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.0231 212.647) rotate(180) scale(19.1173 19.1165)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5A700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_2",
    x1: 33.2701,
    y1: 259.347,
    x2: 33.2701,
    y2: 245.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#906361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5888D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_2",
    x1: 38.4432,
    y1: 253.797,
    x2: 25.8965,
    y2: 253.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77CBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974577"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.2752 96.6946) rotate(-148.887) scale(68.4802 68.4802)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F9500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.3676 179.702) rotate(-148.887) scale(39.6813 39.6813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D6400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_2",
    x1: 54.322,
    y1: 125.824,
    x2: -9.49187,
    y2: 87.3089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977277"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_2",
    x1: 42.0787,
    y1: 211.576,
    x2: 77.7284,
    y2: 152.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977277"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.852 102.237) rotate(-148.887) scale(72.0084)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBC000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5A700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_2",
    x1: -3.38381,
    y1: 184.841,
    x2: 49.1867,
    y2: 97.7383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#977277"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 125,
    fill: "white",
    transform: "matrix(-1 0 0 1 112.909 204)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationPlant);
export default __webpack_public_path__ + "static/media/ConfirmationPlant.333bf7458455144e95a73109729b0308.svg";
export { ForwardRef as ReactComponent };